import type { SVGProps } from 'react';

export function BirdhouseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 1a3 3 0 0 1 1.763.574l7.82 5.614a1 1 0 0 1-1.166 1.625l-.745-.536L18.185 17H20a1 1 0 0 1 0 2h-7v3a1 1 0 0 1-2 0v-3H4a1 1 0 0 1 0-2h1.815L4.327 8.277l-.744.536a1 1 0 0 1-1.166-1.626l7.82-5.614A3 3 0 0 1 12 1m0 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6" />
    </svg>
  );
}
